import { useNavigate } from 'react-router-dom';
import DataTableWrapper from '../../../Utility/DataTableWrapper/DataTableWrapper';
import { useContext, useEffect, useRef, useState } from 'react';
import { BandoService } from '../../../../services/BandoService';
import ToastContext from '../../../../contexts/toast';
import Modal from '../../../Utility/Modal/Modal';
import { FormUtility } from '../../../Utility/FormUtility';

export default function GestioneAvvisi() {
  console.log('inside gestione avvisi');
  const [dtOptions, setDtOptions] = useState({});
  const navigate = useNavigate();

  const [bando, setBando] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const bandoService = new BandoService();
  const utility = new FormUtility();

  const toastContext = useContext(ToastContext);

  const dtRef = useRef();

  useEffect(() => {
    console.log('cambiato dtoptions', dtOptions);
  }, [dtOptions]);

  const gotoGestioneAvviso = () => {
    navigate('/gestione-avviso');
  };

  const gotoModificaAvviso = (avvisoId) => {
    navigate('/gestione-avviso/' + avvisoId);
  };

  const handleModalAction = () => {
    bandoService.delete(bando).then(() => {
      dtRef.current.rerenderDatatable();
      setModalOpen(false);
      toastContext.success('Avviso eliminato con successo!', 6000);
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
		});
  };

  const eliminaAvviso = (avviso) => {
    if (avviso.fasi.length > 0) {
      return;
    }

    setModalOpen(true);
    setBando(avviso.id);
  };

  useEffect(() => {
    const dtOpt = {
      columns: [
        {
          name: 'Id',
          data: 'id',
          visible: true,
          sortable: true,
          searchable: false,
        },
        {
          name: 'Titolo Avviso',
          data: 'nome',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Descrizione',
          data: 'descrizione',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Anno Scolastico',
          data: 'annoEducativo',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'ISEE minimo',
          data: 'iseeMin',
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => {
            return row.iseeMin.toLocaleString('it-IT', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          }
        },
        {
          name: 'ISEE massimo',
          data: 'iseeMax',
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => {
            return row.iseeMax.toLocaleString('it-IT', {
               style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          }
        },
        {
          name: 'Azioni',
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => (
            <div
              className='rtds-inline-flex rtds-gap-1'
              role='group'
              aria-label='Azioni'
            >
              <button
                type='button'
                className='rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => gotoModificaAvviso(row.id)}
              >
               <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                  />
                </svg>
                Modifica
              </button>{' '}
              <button
                type='button'
                className= 'rtds-btn--danger rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => eliminaAvviso(row)}
                disabled={row.fasi.length > 0}
                title={row.fasi.length > 0 ? 'Impossibile eliminare per fasi agganciate all\'avviso' : 'Elimina avviso'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--trash`}
                  />
                </svg>
                Elimina
              </button>
            </div>
          ),
        },
      ],
      serverSide: true,
      ajax: bandoService.getAllDt,
      rows: [
        /*{ id: 1, title: 'test 123', year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative avviso del 23/24' }*/
      ],
      sorts: [],
      hideSearch: false,
      title: 'Elenco Avvisi'
    };
    setDtOptions(dtOpt);
    loadData();
  }, []);

  const loadData = async () => {
    // let rows= [];
    // for (let i = 1;i<400;i++){
    //     rows.push({ id: i, title: 'test ' + i, year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative avviso del 23/24' });
    // }
    // setDtOptions((dtOptions)=> ({...dtOptions,rows}));
  };

  return (
    <>
      <div className="rtds-container rtds-py-6">
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          <div className="rtds-flex rtds-items-center rtds-justify-between">
            <h1 className="rtds-heading-2">Gestione Avvisi</h1>
          </div>
        </div>
      </div>
      <DataTableWrapper
        ref={dtRef}
        dtOptions={dtOptions}
        headerButton={
          <button
            type="button"
            className="rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
            onClick={gotoGestioneAvviso}
          >
            <svg
              className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use
                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
              />
            </svg>
            Inserisci&nbsp;nuovo&nbsp;Avviso
          </button>
        }
      />

      <Modal
        isOpen={isModalOpen}
        title="Elimina Avviso"
        content="Sei sicuro di voler eliminare questo avviso? Una volta rimosso, non potrai recuperarlo."
        onClose={() => setModalOpen(false)}
        onAction={handleModalAction}
        actionLabel="Conferma"
        closeLabel="Annulla"
      />
    </>
  );
}
